/**
 * دادهٔ تستی برای تمام گزارش‌ها (نمودار و جدول) بدون وابستگی به بک‌اند.
 *
 * فعال‌سازی سریع: این مقدار را `true` کنید.
 * یا در `.env.local`: REACT_APP_REPORTS_MOCK=true
 *
 * قبل از build/production حتماً false بماند یا env تنظیم نشود.
 */
const LOCAL_TOGGLE = false;

const env = typeof process.env.REACT_APP_REPORTS_MOCK === 'string'
  ? process.env.REACT_APP_REPORTS_MOCK.toLowerCase()
  : '';

const ENABLED_BY_ENV = env === 'true' || env === '1' || env === 'yes';

export const REPORTS_API_USE_MOCK_DATA = LOCAL_TOGGLE || ENABLED_BY_ENV;
